/** The shop's operational settings. */
const settings = {
  en: {
    title: "Settings",
    subtitle: "How your shop's tills and menu behave",
    loadFailed: "Could not load your settings.",
    saveFailed: "Could not save your settings.",
    saved: "Settings saved.",
    ownerOnly: "Only the shop owner can change these.",
    shopSection: "Shop",
    defaultLanguage: "Default language",
    defaultLanguageHint:
      "The language your tills and dashboard open in, until someone picks another on that device.",
    lowStock: "Low-stock warning",
    lowStockHint:
      "A product counts as running low once its stock is at or below this number.",
    lowStockPush:
      "Notify the team when a product reaches its low-stock threshold",
    deviceSection: "This device",
    deviceLanguage: "Language on this device",
    deviceLanguageHint:
      "Only changes this phone, tablet or computer, and is remembered here.",
  },

  fr: {
    title: "Paramètres",
    subtitle: "Le comportement des caisses et du menu de votre boutique",
    loadFailed: "Impossible de charger vos paramètres.",
    saveFailed: "Impossible d'enregistrer vos paramètres.",
    saved: "Paramètres enregistrés.",
    ownerOnly: "Seul le propriétaire de la boutique peut les modifier.",
    shopSection: "Boutique",
    defaultLanguage: "Langue par défaut",
    defaultLanguageHint:
      "La langue d'ouverture de vos caisses et du tableau de bord, tant que personne n'en choisit une autre sur l'appareil.",
    lowStock: "Alerte de stock bas",
    lowStockHint:
      "Un produit est signalé en stock bas dès que son stock atteint ce nombre ou moins.",
    lowStockPush:
      "Prévenir l'équipe quand un produit atteint son seuil de stock bas",
    deviceSection: "Cet appareil",
    deviceLanguage: "Langue sur cet appareil",
    deviceLanguageHint:
      "Ne change que ce téléphone, cette tablette ou cet ordinateur ; le choix est mémorisé ici.",
  },

  ar: {
    title: "الإعدادات",
    subtitle: "طريقة عمل نقاط البيع وقائمة متجرك",
    loadFailed: "تعذّر تحميل الإعدادات.",
    saveFailed: "تعذّر حفظ الإعدادات.",
    saved: "تم حفظ الإعدادات.",
    ownerOnly: "لا يمكن تغيير هذه الإعدادات إلا لمالك المتجر.",
    shopSection: "المتجر",
    defaultLanguage: "اللغة الافتراضية",
    defaultLanguageHint:
      "اللغة التي تُفتح بها نقاط البيع ولوحة التحكم، إلى أن يختار أحدهم لغة أخرى على ذلك الجهاز.",
    lowStock: "تنبيه انخفاض المخزون",
    lowStockHint:
      "يُعتبر المنتج منخفض المخزون عندما يصل مخزونه إلى هذا الرقم أو أقل.",
    lowStockPush: "إشعار الفريق عند وصول منتج إلى حد انخفاض المخزون",
    deviceSection: "هذا الجهاز",
    deviceLanguage: "لغة هذا الجهاز",
    deviceLanguageHint:
      "يغيّر هذا الهاتف أو الجهاز اللوحي أو الحاسوب فقط، ويُحفظ الاختيار عليه.",
  },
};

export default settings;
